module.exports = __webpack_public_path__ + "c5efc28b64f1ddd0f62076c4207645f8.woff2";